import VehicleDetail from "./VehicleDetail";
import { vehiclesData } from "../data/vehiclesData";

function MercedesClasseS() {
  return <VehicleDetail vehicle={vehiclesData.mercedesS} />;
}

export default MercedesClasseS;